<script setup>
// регистрация
import {useField, useForm} from "vee-validate";
import * as yup from "yup";
import axios from "axios";
import {ref} from "vue";

const isDateValid = ref(true)
const isContractValid = ref(true)
const isCertificateValid = ref(true)
const isRegNumValid = ref(true)

const isRegisterSuccess = ref(false)
const isContractExist = ref(false)
const isCertificateExist = ref(false)
// в номер есть в db
const isRegnumExist = ref(false)
// в номер есть файлах base*
const isRegnumNoExist = ref(false)

// варианты регистрации

const contractType = ref(0)
const contractTypes = ref(
    [
        { name: 'Да', isActive: false },
        { name: 'Нет', isActive: false },
])

const certificateType = ref(0)
const certificateTypes = ref(
    [
      { name: 'Да', isActive: false },
      { name: 'Нет', isActive: false },
    ])

const { handleSubmit, isSubmitting } = useForm();
const { value:surname, errorMessage:surnameError } = useField(
    'surname',
    yup
        .string()
        .trim()
        .required()
);
const { value:name, errorMessage:nameError } = useField(
    'name',
    yup
        .string()
        .trim()
        .required()
);
const { value:midname, errorMessage:midnameError } = useField(
    'midname',
    yup
        .string()
        .trim()
        .required()
);
const { value:date, errorMessage:dateError } = useField(
    'date',
    yup
        .string()
        .trim()
        .required()
        .length(10,'#')
);
const { value:phone, errorMessage:phoneError } = useField(
    'phone',
    yup
        .string()
        .trim()
        .required()
        .length(18,'#')

);
const { value:email, errorMessage:emailError } = useField(
    'email',
    yup
        .string()
        .trim()
        .required()
        .email('')
);
const { value:contract } = useField(
    'contract',
    yup
        .string()
        .trim()
);
const { value:certificate } = useField(
    'certificate',
    yup
        .string()
        .trim()
);
const { value:regnum } = useField(
    'regnum',
    yup
        .string()
        .trim()
);

//----------------------------------------------------------------------
// валидация даты рождения
const validateDate = (date) => {
  let isDateValid = true
  let dateArr = date.split('.')
  //getMonth() c 0
  let m = dateArr[1]-1
  let newDate = new Date(dateArr[2], m, dateArr[0]);
  if (newDate.getFullYear() === +dateArr[2] && newDate.getMonth() === m && newDate.getDate() === +dateArr[0]) {
    let now = new Date();
    if (dateArr[2] > now.getFullYear()-18 || dateArr[2] < now.getFullYear()-100 ){
      isDateValid = false
    }
  } else {
    isDateValid = false
  }
  return isDateValid
}
//----------------------------------------------------------------------
// валидация идентификатора договора
const validateContract = (contract) => {  
  if (contractType.value === 1 && (contract === undefined || contract === '' || contract.length != 13)){
    return false
  }
  return true
}
//----------------------------------------------------------------------
// валидация номера свидетельства
const validateCertificate = (certificate) => {
  if (certificateType.value === 1 && (certificate === undefined || certificate === '' || certificate.length != 7)){
    return false
  }
  return true
}
//----------------------------------------------------------------------
// валидация рег. номера
const validateRegNum = (regNum) => {
  if (certificateType.value === 2 && (regNum === undefined || regNum === '')){
    return false
  }
  return true
}
//----------------------------------------------------------------------
// есть ли идентификатор договора
const setContractType = (index) => {
  contractTypes.value.forEach(function(item, i) {
    item.isActive = i === index;
  });

  contractType.value = index + 1;
  certificate.value = ''
  regnum.value = ''

  if (contractType.value === 1) {
    certificateType.value = 0
    certificateTypes.value.forEach(function(item) {
      item.isActive = false;
    });

    setTimeout(() => document.querySelector("#contract").focus(), 300);

  }

  setTimeout(() => scrollToBottom(), 500);
}
//----------------------------------------------------------------------
// есть ли свидетельство
const setCertificateType = (index) => {
  certificateTypes.value.forEach(function(item, i) {
    item.isActive = i === index;
  });
  contract.value = ''
  certificateType.value = index + 1;
  if (certificateType.value === 1) {
    setTimeout(() => document.querySelector("#certificate").focus(), 300);
    regnum.value = ''
  } else if (certificateType.value === 2) {
    setTimeout(() => document.querySelector("#regnum").focus(), 300);
    certificate.value = ''
  }
  setTimeout(() => scrollToBottom(), 500);

}

//----------------------------------------------------------------------

const repeatRegistration = () => {
  isRegisterSuccess.value = false
  isContractExist.value = false
  isCertificateExist.value = false
  isRegnumExist.value = false
  isRegnumNoExist.value = false
}
//----------------------------------------------------------------------

// прокрутить окно вверх при ошибке
const moveToError = () => {
  const modal = document.querySelector("#contacts")
  if ((surname.value == undefined || surname.value == '')
    || (name.value == undefined || name.value == '')
    || (midname.value == undefined || midname.value == '')
    || (date.value == undefined || date.value == '')
    || (phone.value == undefined || phone.value == '')
    || (email.value == undefined || email.value == '')
  ){
    modal.scrollTo({
      behavior: 'smooth',
      top: 0,
    })
  }
}

// отправить форму
const onSubmit = handleSubmit(async (values) => {

  try {
    const modal = document.querySelector("#contacts")
    isDateValid.value = validateDate(values['date'])

    if (!isDateValid.value){
      modal.scrollTo({
        behavior: 'smooth',
        top: 0,
      })
    } else {
      isContractValid.value = validateContract(values['contract'])
      isCertificateValid.value = validateCertificate(values['certificate'])
      isRegNumValid.value = validateRegNum(values['regnum'])
    }

    if (isDateValid.value && isContractValid.value && isCertificateValid.value && isRegNumValid.value) {

      //Если заголовок Content-Type имеет значение отличное от application/x-www-form-urlencoded,
      //https://qna.habr.com/q/447033
      //браузер сделает два HTTP-запроса + OPTIONS

      const headers = {
        'Content-Type': 'application/x-www-form-urlencoded'
      }

      const url = process.env.VUE_APP_API + "register.php"
      const {data} = await axios.post(url, values, {
        headers: headers
      })

      if (data['status'] === 'SUCCESS') {
        isRegisterSuccess.value = true
      } else if (data['status'] === 'CONTRACT_EXIST'){
        isContractExist.value = true
      } else if (data['status'] === 'CERTIFICATE_EXIST'){
        isCertificateExist.value = true
      } else if (data['status'] === 'REGNUM_EXIST_IN_DB'){
        isRegnumExist.value = true
      } else if (data['status'] === 'REGNUM_NO_EXIST_IN_FILES'){
        isRegnumNoExist.value = true
      } else {
        alert ('SQL_SERVER_ERROR')
      }

    }

  } catch (e) {
    alert ('INTERNAL_SERVER_ERROR')
  }

})

//----------------------------------------------------------------------

// eslint-disable-next-line no-undef,no-unused-vars
const emit = defineEmits(['success'])

// перемещение вниз окна
const scrollToBottom = () => {
  const modal = document.querySelector("#contacts")
  modal.scrollTo({
      behavior: 'smooth',
      top: modal.clientHeight,
  })
}
</script>

<template>

  <div class="modal-body" id="contacts">

    <form @submit="onSubmit" v-if="!isRegisterSuccess && !isContractExist && !isCertificateExist && !isRegnumExist && !isRegnumNoExist">

      <div class="info mt-3 mb-4">
        <div class="text-center">
          <v-icon
              class="question-icon--red"
              icon="mdi:alert-circle-outline"
          ></v-icon>
          <h5>Для регистрации необходимо указывать ФИО и дату рождения основного участника</h5>
        </div>
      </div>

      <div class="row">

        <div class="col-md-4 col-sm-12">
          <div class="form-group mt-2">
            <label for="surname">Фамилия</label>
            <input
                type="text"
                id="surname"
                :class="['form-control', {'is-invalid': surnameError}]"
                v-model="surname"
            >
          </div>
        </div>

        <div class="col-md-4 col-sm-12">
          <div class="form-group mt-2">
            <label for="name">Имя</label>
            <input
                type="text"
                id="name"
                :class="['form-control', {'is-invalid': nameError}]"
                v-model="name"
            >
          </div>
        </div>

        <div class="col-md-4 col-sm-12">
          <div class="form-group mt-2">
            <label for="midname">Отчество</label>
            <input
                type="text"
                id="midname"
                :class="['form-control', {'is-invalid': midnameError}]"
                v-model="midname"
            >
          </div>
        </div>

        <div class="col-md-4 col-sm-12">
          <div class="form-group mt-2">
            <label for="date">Дата рождения</label>
            <input
                type="text"
                id="date"
                :class="['form-control', {'is-invalid': dateError || !isDateValid}]"
                v-mask="'##.##.####'"
                placeholder="00.00.0000"
                v-model="date"
            >
          </div>
        </div>

        <div class="col-md-4 col-sm-12">
          <div class="form-group mt-2">
            <label for="phone">Телефон</label>
            <input
                type="text"
                id="phone"
                :class="['form-control', {'is-invalid': phoneError}]"
                v-mask="'+7 (###) ###-##-##'"
                placeholder="+7 (000) 000-00-00"
                v-model="phone"
            >
          </div>
        </div>

        <div class="col-md-4 col-sm-12">
          <div class="form-group mt-2">
            <label for="phone">E-mail</label>
            <input
                type="text"
                id="email"
                :class="['form-control', {'is-invalid': emailError}]"
                v-model="email"
            >
          </div>
        </div>
      </div>

      <div class="info mt-3">
        <div class="text-center">
          <v-icon
              class="question-icon"
              icon="mdi:cloud-question-outline"
          ></v-icon>
          <h5>Вы уже получили содействие и знаете свой идентификатор договора?</h5>
        </div>
        <hr style="background-color: #80b5d3">
        Идентификатор договора – это уникальный 13-и значный номер, который присвоен именно Вашему обязательству и по которому кредитор идентифицирует Ваши  платежи, поступающие в погашение долгового обязательства.
        <br>Его же Вы указываете в поле «Назначение платежа» при ежемесячном переводе средств в адрес кредитора.
      </div>

      <div class="d-flex justify-content-center align-items-center mt-3">
        <div
            v-for="(item,index) in contractTypes" :key="item.name"
            :class="['item-type', {'item-active': item.isActive}]"
            @click="setContractType(index)"
        >
          {{ item.name }}
        </div>
      </div>

      <div v-if="contractType === 1">
        <div class="text-center m-2"><strong>Укажите идентификатор договора</strong></div>
        <input
            type="text"
            id="contract"
            :class="['form-control assistance-input', {'is-invalid': !isContractValid}]"
            v-mask="'#############'"
            placeholder="0000000000000"
            v-model="contract"
        >
      </div>

      <div v-if="contractType === 2" class="mt-3">
        <div class="info text-center">
          <v-icon
              class="question-icon"
              icon="mdi:cloud-question-outline"
          ></v-icon>
          <h5>Вы уже получили cвидетельство о предоставлении займа?</h5>
        </div>
        <div class="d-flex justify-content-center align-items-center mt-3">
          <div
              v-for="(item,index) in certificateTypes" :key="item.name"
              :class="['item-type', {'item-active': item.isActive}]"
              @click="setCertificateType(index)"
          >
            {{ item.name }}
          </div>
        </div>

        <div v-if="certificateType === 1">
          <div class="text-center m-2"><strong>Укажите номер свидетельства</strong></div>
          <input
              type="text"
              id="certificate"
              :class="['form-control assistance-input', {'is-invalid': !isCertificateValid}]"
              v-mask="'З-#####'"
              placeholder="З-00000"
              v-model="certificate"
          >
        </div>

        <div v-if="certificateType === 2">
          <div class="text-center m-2"><strong>Укажите регистрационый номер учетного дела</strong></div>
          <input
              type="text"
              id="regnum"
              :class="['form-control assistance-input', {'is-invalid': !isRegNumValid}]"
              v-model="regnum"
          >
        </div>
      </div>

      <hr>

      <div v-if="contractType === 1 || certificateType > 0" class="text-center p-2 mb-4">
        <button
          type="submit"
          class="btn btn-send btn-block fs-15 m-auto"
          style="font-size: 1.4rem;width: 280px;"
          :disabled="isSubmitting"
          @click="moveToError"
      >
        <svg v-if="isSubmitting"
             xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><g>
          <circle cx="3" cy="12" r="2" fill="#80b5d3"/>
          <circle cx="21" cy="12" r="2" fill="#80b5d3"/>
          <circle cx="12" cy="21" r="2" fill="#80b5d3"/>
          <circle cx="12" cy="3" r="2" fill="#80b5d3"/>
          <circle cx="5.64" cy="5.64" r="2" fill="#80b5d3"/>
          <circle cx="18.36" cy="18.36" r="2" fill="#80b5d3"/>
          <circle cx="5.64" cy="18.36" r="2" fill="#80b5d3"/>
          <circle cx="18.36" cy="5.64" r="2" fill="#80b5d3"/>
          <animateTransform attributeName="transform" dur="1.5s" repeatCount="indefinite" type="rotate" values="0 12 12;360 12 12"/></g>
        </svg>
        <span v-else>Зарегистрироваться</span>
      </button>
      </div>
      <p>В соответствии со статьей 9 Федерального закона от 27.07.2006 № 152-ФЗ «О персональных данных» даю согласие на обработку моих персональных данных, необходимых для предоставления услуги.</p>
    </form>

    <div v-else-if="isRegisterSuccess">
      <div class="text-center pb-2">
        <v-icon
            class="success-icon--green"
            icon="mdi:check-circle-outline"
        ></v-icon>
      </div>
      <p>Чтобы завершить процесс регистрации в сервисе «Личный кабинет клиента СПБ ЦДЖ», перейдите по ссылке в письме,
        отправленном на указанный Вами электронный адрес:</p>
        <h4 class="text-center mt-2">{{ email }}</h4>
    </div>

    <div v-else-if="isContractExist">
      <div class="text-center pb-2">
        <v-icon
            class="error-icon--red"
            icon="mdi:alert-circle-outline"
        ></v-icon>
      </div>
      <div class="text-center">
        Указанные Вами идентификатор договора  <h4 class="mt-2">{{ contract }}</h4> уже используется.
        <br>
        <button
            class="btn btn-danger mt-4"
            style="width: 280px"
            @click="repeatRegistration()"
        >Повторить регистрацию</button>
      </div>
    </div>

    <div v-else-if="isCertificateExist">
      <div class="text-center pb-2">
        <v-icon
            class="error-icon--red"
            icon="mdi:alert-circle-outline"
        ></v-icon>
      </div>
      <div class="text-center">
        Указанные Вами номер свидетельства  <h4 class="mt-2">{{ certificate }}</h4> уже используется.
        <br>
        <button
            class="btn btn-danger mt-4"
            style="width: 280px"
            @click="repeatRegistration()"
        >Повторить регистрацию</button>
      </div>
    </div>

    <div v-else-if="isRegnumExist">
      <div class="text-center pb-2">
        <v-icon
            class="error-icon--red"
            icon="mdi:alert-circle-outline"
        ></v-icon>
      </div>
      <div class="text-center">
        Указанные Вами регистрационный номер  <h4 class="mt-2">{{ regnum }}</h4>уже используется.
        <br>
        <button
            class="btn btn-danger mt-4"
            style="width: 280px"
            @click="repeatRegistration()"
        >Повторить регистрацию</button>
      </div>
    </div>

    <div v-else-if="isRegnumNoExist">
      <div class="text-center pb-2">
        <v-icon
            class="error-icon--red"
            icon="mdi:alert-circle-outline"
        ></v-icon>
      </div>
      <div class="text-center">
        Указанные Вами регистрационный номер  <h4 class="mt-2">{{ regnum }}</h4> не существует или еще не зарегистрирован в системе,
        это может занимать некоторое время.<br>Попробуйте зарегистрироваться позднее.
        <br>
      </div>
    </div>
  </div>

</template>
<style scoped>
.info{
  background-color: #d5e5fa;
  padding: 20px;
  border-radius: 5px;
}
.item-type{
  margin: 15px;
  background-color:#d5e5fa;
  padding:19px 10px;
  font-size:21px;
  font-weight: bold;
  text-align:center;
  cursor:pointer;
  border-radius: 50px;
  -moz-border-radius: 50px;
  -webkit-border-radius: 50px;
  width:70px;
  transition: 0.2s;
}
.item-active{
  background-color:#80b5d3 !important;
  color:#fff;
}
.assistance-input{
  width:250px;
  margin:0 auto 10px auto;
}
.question-icon{
  width:60px;
  height:50px;
  color: #54a5d3;
  margin: 0 0 10px 0;
}
.question-icon--red{
  width:50px;
  height:50px;
  color: #f33c38;
  margin: 0 0 10px 0;
}
</style>